@if (queryShowed) {
    <craig-streaming-active-conversation></craig-streaming-active-conversation>
    <craig-streaming-user-input></craig-streaming-user-input>
} @else {
    <craig-streaming-instructions></craig-streaming-instructions>
}
